import React from "react";
import { FileArchive, FileSpreadsheet, FileText, type LucideIcon } from "lucide-react";
import { FundParseOutputFile } from "./fundParseTypes";

interface OutputFileThumbnailProps {
    file: FundParseOutputFile;
    label?: string;
    onClick: (file: FundParseOutputFile) => void;
}

function thumbnailIcon(fileName: string): LucideIcon {
    const lowerName = fileName.toLowerCase();
    if (lowerName.endsWith(".zip")) {
        return FileArchive;
    }
    if (lowerName.endsWith(".csv") || lowerName.endsWith(".txt")) {
        return FileText;
    }
    return FileSpreadsheet;
}

export function OutputFileThumbnail({ file, label, onClick }: OutputFileThumbnailProps): React.ReactElement {
    const Icon = thumbnailIcon(file.fileName);
    const displayLabel = label || file.fileName;
    const showFileName = Boolean(label && label !== file.fileName);

    return (
        <button
            type="button"
            onClick={() => onClick(file)}
            className="flex h-full min-h-[8.5rem] w-full min-w-0 flex-col items-center rounded-lg border border-gray-300 bg-white p-3 text-center shadow-sm transition hover:border-sky-500 hover:bg-sky-50"
            title={`Download ${file.fileName}`}
        >
            <Icon className="mb-2 h-10 w-10 shrink-0 text-sky-600" aria-hidden="true" />
            <span className="line-clamp-3 w-full break-words text-xs font-medium leading-snug text-gray-800">{displayLabel}</span>
            {showFileName ? (
                <span className="mt-1 line-clamp-2 w-full break-all text-[10px] leading-snug text-gray-500">{file.fileName}</span>
            ) : null}
        </button>
    );
}
